"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerDealLabel = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _CatalogueOfferLabel = require("./CatalogueOfferLabel");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const InnerDealLabel = ({
  label,
  type,
  catalogueLabel,
  catalogueUrl,
  offerLabelSmallerOnMobile,
  productCode,
  tooltipTitle,
  size = 'medium'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (type === 'Offer' && tooltipTitle) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CatalogueOfferLabel.CatalogueOfferLabel, {
      catalogueLabel: catalogueLabel,
      catalogueUrl: catalogueUrl,
      offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
      tooltipTitle: tooltipTitle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
        isSuper: true,
        "aria-label": label ?? undefined,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": `${getTestId(_common.LABEL_OFFER)}-${productCode}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTagFilled, {})
      })
    });
  }
  switch (type) {
    case 'Offer':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
        isOffer: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": `${getTestId(_common.LABEL_OFFER)}-${productCode}`,
        title: label ?? undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTagFilled, {
          fontSize: "inherit"
        })
      });
    case 'SuperDeal':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
        isSuper: true,
        offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
        "data-testid": `${getTestId(_common.LABEL_SUPER_DEAL)}-${productCode}`,
        title: label ?? undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.SuperdealFilled, {
          fontSize: "inherit"
        })
      });
    case 'NewEditionAvailable':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
        label: label,
        size: size,
        color: "primary",
        "data-testid": `${getTestId(_common.NEW_EDITION_AVAILABLE_LABEL)}-${productCode}`
      });
    case 'NewEdition':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
        label: label,
        size: size,
        color: "primary",
        "data-testid": `${getTestId(_common.NEW_EDITION_LABEL)}-${productCode}`
      });
    case 'New':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
        label: label,
        size: size,
        color: "primary",
        "data-testid": `${getTestId(_common.LABEL_NEW)}-${productCode}`
      });
    default:
      return null;
  }
};
exports.InnerDealLabel = InnerDealLabel;
//# sourceMappingURL=InnerDealLabel.js.map